import styled from 'styled-components';
import {Box} from '../../styles/page';

export const PasswordBox = styled(Box)`
  margin-top: 2rem;
  margin-bottom: 10rem;
`;
